"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _ActionsSocket = _interopRequireDefault(require("../../../dist/client/ActionsSocket"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var emitActionToServer = function emitActionToServer() {
  return (0, _rxjs.pipe)((0, _operators.tap)(function (action) {
    (0, _ActionsSocket["default"])().emit(action);
  }), (0, _operators.ignoreElements)());
};

var _default = emitActionToServer;
exports["default"] = _default;